// extracted by mini-css-extract-plugin
export default {"form":"TranslateFeedbackVideoForm_form__uvm0x","form-group":"TranslateFeedbackVideoForm_form-group__JYmgG"};